// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__j3e8e","title":"Header_title__DP9BX","side":"Header_side__1VC35"};